import { render, staticRenderFns } from "./UnapproveDonutChart.vue?vue&type=template&id=5393603a&scoped=true"
import script from "./UnapproveDonutChart.vue?vue&type=script&lang=js"
export * from "./UnapproveDonutChart.vue?vue&type=script&lang=js"
import style0 from "./UnapproveDonutChart.vue?vue&type=style&index=0&id=5393603a&prod&scoped=true&lang=css"
import style1 from "./UnapproveDonutChart.vue?vue&type=style&index=1&id=5393603a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393603a",
  null
  
)

export default component.exports